/* Keep the journal's article search separate from product-search integrations. */
(function () {
  // The filter app otherwise rewrites the query and removes archive pagination.
  var pageUrl = new URL(window.location.href);
  if (/\/search$/.test(pageUrl.pathname) && pageUrl.searchParams.get('view') === 'articles') {
    window.enabledEmbedFilter = false;
    if (window.GloboFilterGlobalConfig) window.GloboFilterGlobalConfig.isSearchPage = false;
    document.documentElement.classList.remove('spf-filter-loading', 'spf-has-filter', 'gf-left', 'spf-filter-tree-theme', 'spf-layout-app');
  }
  if (window.rljArticleSearchReady) return;
  window.rljArticleSearchReady = true;
  window.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form.matches || !form.matches('[data-rlj-article-search]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    var query = form.querySelector('[name="q"]').value.trim();
    if (!query) return;
    var url = new URL(form.action, window.location.origin);
    url.searchParams.set('view', 'articles');
    url.searchParams.set('type', 'article');
    url.searchParams.set('q', query);
    url.searchParams.set('options[prefix]', 'last');
    window.location.assign(url.href);
  }, true);
}());
